.containerHome {
    padding-inline: 20px;
    padding-bottom: 56px;
    @media only screen and (min-width: 768px) {
        padding-inline: 0px;
    }
}
